<template>
    <div class="container">
        <div class="row">
            <heading>{{ $t('terminals.menuName') }}
                <template v-slot:actions>
                    <a href="/settings/terminal/create" class="btn btn-primary mr-2">{{ $t('core.actions.new') }}</a>
                </template>
            </heading>
        </div>
        <div class="row">
            <settingMenu></settingMenu>
            <div class="card col-10">
                <div class="card-body">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="border-top-0">{{ $t('terminals.fields.name') }}</th>
                            <th class="border-top-0"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="terminal in terminals">
                            <td>{{ terminal.name }}</td>
                            <td class="text-right">
                                <a class="btn btn-sm btn-outline-primary" :href="'/settings/terminal/' + terminal.id">{{ $t('terminals.edit') }}</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import SettingMenu from '@/Components/SettingMenu'
export default {
    name: 'TerminalsIndex',
    components: { SettingMenu },
    data: () => {
        return {
            terminals: lgt.terminals
        }
    },
}
</script>

